export default __webpack_public_path__ + "static/media/masterCard.7d693fa7.png";